<template>
  <div>
    <b-modal v-show="showPanel" id="rightPanelModal" size="lg" @hide="onHide" ref="rightPanelModal" no-close-on-backdrop no-close-on-esc modal-class="right" content-class="custom-modal-content" dialog-class="custom-modal-dialog" :hide-backdrop="modalHideBackdrop">
      <slot name="modal-header">
        <div class="">
          <a href="javascript:void(0);" @click="hide" class="text-uppercase text-muted pt-1"><img class="back_icon mr-2" src="@/assets/manager/back_button_icon.png" />Back</a>
          <button type="button" class="close" @click="hide">
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
      </slot>
      <slot name="body">Default body content</slot>
    </b-modal>
  </div>
</template>

<script>
export default {
  props: {
    modalHideBackdrop: {
      type: Boolean,
      default: false,
    },
    showPanel: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
    }
  },
  computed: {
    
  },
  methods: {
    onHide() {
      this.$emit('hide');
    },
    show() {
      this.$refs.rightPanelModal.show();
    },
    hide() {
      this.$refs.rightPanelModal.hide();
    },
  },
  components: {
    
  },
  created() {
    
  },
  mounted() {

  }
}
</script>

<style>
@import '../../assets/styles/style_v2.css';
</style>

<style scoped>
.back_icon { width: 14px; }
</style>


// WEBPACK FOOTER //
// src/components/manager/right_panel_modal.vue